import gql from 'graphql-tag';
import { apollo } from 'src/features';
import { serverError } from 'src/utils';

const mutation = gql`
mutation Customer($name: String!){
  signinAnonymous(name: $name) {
    token
    authorizable {
      ... on Customer {
        id
        firstName
      }
    }
  }
}`;

const fieldsName = {
  first_name: 'T_YOUR_USER_NAME',
};

function onParseErrors(item) {
  return serverError.interpolation(item, fieldsName);
}

function parse(item) {
  return {
    token: item.token,
    customer: {
      id: item.authorizable.id,
      title: item.authorizable.firstName,
      firstName: item.authorizable.firstName,
      identified: false,
    },
  };
}

function signinAnon(name) {
  return apollo.client.mutate({
    variables: {
      name,
    },
    mutation,
  }).then((res) => parse(res.data.signinAnonymous))
    .catch((err) => {
      if (err.graphQLErrors.length) {
        const errors = err.graphQLErrors[0].error.payload;
        throw errors.map(onParseErrors);
      } else {
        throw err;
      }
    });
}

export default signinAnon;
